export default {
      id: "driver_assigned-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#driver_assigned",
      toString: function () {
        return this.url;
      }
    }